<template>
  <div class="featuress-area ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="features-content-three position-relative z-1">
            <span class="top-title">مميزات السيرفر</span>
            <h2>نوفر لك أقوى اشتراكات IPTV بثبات تام وبأفضل سعر</h2>
            <p>
              استمتع بمشاهدة بدون تقطيع من خلال سيرفراتنا المجهزة بأحدث التقنيات لضمان جودة بث خارقة حتى مع اتصالات الإنترنت المتوسطة.
            </p>
            <ul class="ps-0 list-unstyled features-list">
              <li class="d-flex align-items-center mb-2">
                <i class="ti ti-circle-check ms-2 text-success fs-5"></i>
                <span>ثبات أسطوري أثناء المباريات والقمم الكروية الكبرى</span>
              </li>
              <li class="d-flex align-items-center mb-2">
                <i class="ti ti-circle-check ms-2 text-success fs-5"></i>
                <span>مكتبة ضخمة من الأفلام والمسلسلات بجودة 4K و FHD</span>
              </li>
              <li class="d-flex align-items-center mb-2">
                <i class="ti ti-circle-check ms-2 text-success fs-5"></i>
                <span>تحديثات تلقائية وفورية للمحتوى والترجمة الاحترافية</span>
              </li>
            </ul>
            <div class="d-flex starting-wrap">
              <div class="starting">
                <span class="startings">تبدأ الأسعار من</span>
                <h1>25.00 €<sub>/ 3 أشهر</sub></h1>
              </div>
              <div class="google-rate">
                <img src="@/assets/images/google.png" alt="google" />
                <p>تقييمات الزبائن <span>4.7</span></p>
              </div>
            </div>
            
            <a href="https://wa.me/447429916178" target="_blank" class="btn">
              <span class="border-style">تواصل معنا واشترك الآن</span>
            </a>
            
            <img
              src="@/assets/images/shape-16.png"
              class="shape shape-17"
              alt="shape"
            />
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="features-img">
            <img src="@/assets/images/features-img-1.png" alt="features-img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ProvidesNetworkAtVeryCheapPrice",
});
</script>